// Generic error code with the generic error message
export const FeV2GenericErrorCodes = [
  801, 802, 805, 806, 807, 808, 809, 811, 817, 818, 820, 821, 823, 824, 825,
  842, 844, 853, 857, 863, 874, 862,
] as const;

export const FeV2ErrorCodes = [
  400, 803, 804, 810, 813, 814, 816, 819, 826, 827, 828, 829, 830, 831, 832,
  833, 843, 849, 850, 851, 852, 854, 856, 858, 859, 860, 861, 870, 871, 872,
  873, 60015,
] as const;

export type FeV2GenericErrorCodesType = (typeof FeV2GenericErrorCodes)[number];
export type FeV2ErrorCodesType = (typeof FeV2ErrorCodes)[number];

export interface IFeV2ErrorCode {
  code: FeV2GenericErrorCodesType | FeV2ErrorCodesType;
  message: string;
}
